import { render, staticRenderFns } from "./NewUpload.vue?vue&type=template&id=37c82ad7&"
import script from "./NewUpload.vue?vue&type=script&lang=js&"
export * from "./NewUpload.vue?vue&type=script&lang=js&"
import style0 from "./NewUpload.vue?vue&type=style&index=0&id=37c82ad7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports